import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import iconSuccess from '@panel/commons/assets/img/success.svg';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { site } from '@panel/commons/helpers/siteUtils';
import { CompletedPaymentContainer } from '../../styles';
import { updateLastStep } from '../../../../../ducks/stepper';

function PaymentSuccess() {
  const location = useLocation();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const sendDatalayer = () => {
    if (location.state) {
      const { idOrder, total, taxes, productId, title, paymentMethod } = location.state;
      window.dataLayer.push({
        event: 'transaction',
        ecommerce: {
          purchase: {
            actionField: {
              id: idOrder,
              affiliation: 'Publicador de avisos',
              revenue: total,
              tax: taxes,
              dimension2: `TC-${paymentMethod}`
            },
            products: [
              {
                id: productId,
                name: title,
                price: total,
                category: 'Aviso Particulares',
                quantity: '1'
              }
            ]
          },
          flow_type: 'particular'
        }
      });
    }
  };

  useEffect(() => {
    dispatch(updateLastStep('4', '2'));
    sendDatalayer();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <CompletedPaymentContainer isSuccess isBrasil={site.isBrasil}>
      <img src={iconSuccess} alt='successPurchase' />
      <h3>{t('publisher.step4.module2.payment.success.title')}</h3>
      <p>{t('publisher.step4.module2.payment.success.message')}</p>
    </CompletedPaymentContainer>
  );
}

export default PaymentSuccess;
